/* El clic y el teclado siguen funcionando con el <details> nativo de Dawn. */
(() => {
  const desktop = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(menu => {
      if (menu.dataset.creditexHoverReady) return;
      menu.dataset.creditexHoverReady = 'true';
      const details = menu.querySelector('details');
      const summary = details?.querySelector('summary');
      if (!details || !summary) return;
      let timer;

      menu.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach(open => {
            if (open !== details) {
              open.open = false;
              open.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            }
          });
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        }, 170);
      });

      menu.addEventListener('mouseleave', () => {
        clearTimeout(timer);
        if (!desktop.matches) return;
        timer = setTimeout(() => {
          if (menu.contains(document.activeElement)) return;
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }, 200);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
